export enum LoginType {
  Team = 'team',
  Personal = 'personal',
}

export const reCaptchaVerifyUrl =
  'https://www.google.com/recaptcha/api/siteverify'
